import { render, staticRenderFns } from "./RoomCallMixingVideo.vue?vue&type=template&id=dd697c00&scoped=true&"
import script from "./RoomCallMixingVideo.vue?vue&type=script&lang=js&"
export * from "./RoomCallMixingVideo.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallMixingVideo.vue?vue&type=style&index=0&id=dd697c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd697c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd697c00')) {
      api.createRecord('dd697c00', component.options)
    } else {
      api.reload('dd697c00', component.options)
    }
    module.hot.accept("./RoomCallMixingVideo.vue?vue&type=template&id=dd697c00&scoped=true&", function () {
      api.rerender('dd697c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/mixing/RoomCallMixingVideo.vue"
export default component.exports